import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const displayCategories = categories.filter(c => c.slug !== 'all');

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            分类导航
          </h2>
          <p className="text-sm text-foreground-500 mt-1">海量韩国漫画作品，多种类型任你选</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 hover:bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-secondary-100 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-secondary-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}